import React, { Fragment } from 'react';
import Header from '../Components/Header/Header';
import Create from '../Components/Create/Create';

export default function CreatePage() {
  return (
    <>
      <Header />
      <Create />
    </>
  );
};

